/* eslint no-new: "off" */

import Vue from 'vue';

import Axios from './main.axios';
import EventBus from './main.ebus';
import i18n from './main.locale';
import router from './router';
import store from './store';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap';
import './main.validation';
import './main.imports';
import './mixins/logMixin';
import { sync } from 'vuex-router-sync';

import AppComponent from './components/app';

import VueSelect from 'vue-select';

Vue.component('v-select', VueSelect.VueSelect);

Vue.component('ebus', EventBus);

// Sync router to store
sync(store, router);

Axios.get(`/config${document.location.search}`).then((response) => {
  store.dispatch('configuration/setConfiguration', response.data);
  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    ...AppComponent,
  });
});
